import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useMeter} from "../hooks/useMeter.ts";
import {Meter, MeterStatus, MeterType} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useMeter();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                apiKey: '',
                type: MeterType.Sum,
                status: MeterStatus.Draft,
                dimensions: [],
            } as Meter}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
